import { fetchWeddingWebsite } from '@bridebook/web/app-basic/lib/wedding-website/api';
import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';
import { useQuery } from '@tanstack/react-query';
import {
  GetWeddingWebsiteDataBody,
  GetWeddingWebsiteDataResponse,
} from '@bridebook/web/pages/api/for/website/[websiteId]';

export const PUBLIC_WEDDING_WEBSITE_ROOT_QUERY_KEY = 'public-wedding-website';

const CACHE_TIME = toMillis(15, 'min');

export const usePublicWeddingWebsite = (
  websiteId: string,
  params: {
    pin?: GetWeddingWebsiteDataBody['pin'];
  },
  options: {
    keepPreviousData?: boolean;
    initialData?: GetWeddingWebsiteDataResponse;
  },
) => {
  const { data, isLoading, isError, error, isFetching } = useQuery(
    [PUBLIC_WEDDING_WEBSITE_ROOT_QUERY_KEY, 'single', websiteId, params],
    async () => {
      const weddingWebsiteResponse = await fetchWeddingWebsite(websiteId, params);
      if (weddingWebsiteResponse.httpStatus === 200 || weddingWebsiteResponse.httpStatus === 401) {
        return weddingWebsiteResponse.data;
      } else {
        return {
          resultCode: 'error',
        } as const;
      }
    },
    {
      cacheTime: CACHE_TIME,
      staleTime: CACHE_TIME,
      keepPreviousData: options.keepPreviousData,
      initialData: options.initialData,
    },
  );

  return {
    data,
    isLoading,
    isError,
    error,
    isFetching,
  };
};
